// extracted by mini-css-extract-plugin
module.exports = {"actionsCellContainer":"HoldRequestTable_actionsCellContainer__2AYkA","viewRequest":"HoldRequestTable_viewRequest__2pjWU"};